import { IRootState } from '../../../store'
import { IIntubationOptionsState } from '../store/options.types'

export const getIntubationOptionsSelector = (state: IRootState): IIntubationOptionsState =>
  state.options.intubationOptions
